import React from 'react';
import { IIconProps } from '../interfaces';

const WarningTriangle = (props: IIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" fill="none"
             viewBox="0 0 15 14" className={ props.classes }>
            <path fill="#F61362"
                  d="M14.672 10.343 9.585 1.275C9.143.489 8.343 0 7.498 0c-.847 0-1.647.489-2.087 1.275L.324 10.34C.11 10.72 0 11.151 0 11.595 0 12.92.991 14 2.209 14H12.79C14.01 14 15 12.92 15 11.595c0-.443-.111-.876-.324-1.254l-.004.002Zm-1.883 2.49H2.206c-.626 0-1.137-.556-1.137-1.238 0-.228.057-.451.167-.645l5.088-9.068c.248-.441.697-.717 1.172-.717.476 0 .925.274 1.172.717l5.09 9.068c.108.194.165.417.165.645 0 .682-.51 1.239-1.138 1.239h.004Z"/>
            <path fill="#F61362"
                  d="M7.498 2.917c-.297 0-.536.261-.536.584v5.835c0 .323.24.584.536.584.297 0 .537-.261.537-.584V3.5c0-.323-.24-.584-.537-.584ZM7.498 10.5c-.297 0-.536.261-.536.585v.584c0 .323.24.584.536.584.297 0 .537-.261.537-.584v-.584c0-.324-.24-.585-.537-.585Z"/>
        </svg>
    )
};

export default WarningTriangle;